import { EntityTypes } from "../../EntityTypes";
import { IGroupSpaceResource } from "../../group-spaces";
import { IUserResource } from "../../users";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalFilter, RelationalValue, mapRelationalFilterToIRI, mapRelationalValue } from "../../utils/filters";
import { IGroupSpace } from "../types";

export type IGroupSpaceUpdateMutationParameters = {
    groupSpace?: RelationalValue<IGroupSpaceResource>;
    learners?: RelationalFilter<IUserResource>;
    title?: string;
};

export type IGroupSpaceUpdateMutationResult = IGroupSpace;

export const groupSpaceUpdateMutation: IApiMutationFunction<IGroupSpaceUpdateMutationParameters> = ({
    groupSpace,
    learners,
    title,
}) => {
    return {
        method: "PUT",
        url: `/group_spaces/${mapRelationalValue(groupSpace)}`,
        data: {
            learners: mapRelationalFilterToIRI(EntityTypes.USER, learners),
            title,
        },
    };
};

export const useGroupSpaceUpdateMutation = createApiMutationHook<
    IGroupSpaceUpdateMutationParameters,
    IGroupSpaceUpdateMutationResult
>(groupSpaceUpdateMutation);
